module.exports = __webpack_public_path__ + "img/success.8d8ef775.png";